<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ "absence.overview" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div>
      <div class="stretch">
        <div>{{ "common.name" | translate }}:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.user) | async }}
        </div>
      </div>
      <div class="stretch">
        <div>{{ "common.date" | translate }}:</div>
        <div>{{ absenceEntry?.date | date : "dd.MM.yyyy" }}</div>
      </div>

      @if (absenceEntry?.type) {
      <div class="stretch">
        <div>{{ "common.type" | translate }}:</div>
        <div>{{ absenceEntry?.type }}</div>
      </div>
      } @if (absenceEntry?.approvedBy) {
      <div class="stretch">
        <div>{{ "common.status" | translate }}:</div>
        <div class="centered">
          <div>{{ "status.confirmed" | translate }}</div>
          <ion-icon class="green" name="checkmark-circle-outline"></ion-icon>
        </div>
      </div>
      } @if (!absenceEntry?.approvedBy && !absenceEntry?.rejectedBy) {
      <div class="stretch">
        <div>{{ "common.status" | translate }}:</div>
        <div class="centered">
          <div>{{ "status.pending" | translate }}</div>
          <ion-icon class="orange" name="checkmark-circle-outline"></ion-icon>
        </div>
      </div>
      } @if (absenceEntry?.rejectedBy) {
      <div class="stretch">
        <div>{{ "common.status" | translate }}:</div>
        <div class="centered">
          <div>{{ "status.rejected" | translate }}</div>
          <ion-icon class="red" name="checkmark-circle-outline"></ion-icon>
        </div>
      </div>
      } @if (absenceEntry?.description) {
      <div>
        <div>
          <b>{{ "common.description" | translate }}:</b>
        </div>
        <div>{{ absenceEntry?.description }}</div>
      </div>
      }
      <div class="stretch cut">
        <div>{{ "common.created" | translate }}:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.createdBy) | async }}
          ({{ this.tools.formatDt(absenceEntry?.createdUtc) }},
          {{ this.tools.formatTime(absenceEntry?.createdUtc, true) }})
        </div>
      </div>
      @if(absenceEntry?.lastModifiedDateUtc && absenceEntry?.lastModifiedDateUtc
      != absenceEntry?.createdUtc){
      <div class="stretch">
        <div>{{ "common.lastModified" | translate }}:</div>
        <div>
          {{ state.getUserDisplayNameAsync(absenceEntry?.createdBy) | async }}
          ({{ this.tools.formatDt(absenceEntry?.lastModifiedDateUtc) }},
          {{ this.tools.formatTime(absenceEntry?.lastModifiedDateUtc, true) }})
        </div>
      </div>
      }
    </div>

    <div class="stretch">
      @if(absenceEntry?.approvedBy == null || state.userHasMinType(1)){
      <ion-button style="width: 100%" (click)="editWorkDay()">{{
        "common.edit" | translate
      }}</ion-button>

      <ion-button
        style="width: 100%"
        color="danger"
        (click)="deleteAbsenceEntry()"
        >{{ "common.delete" | translate }}</ion-button
      >} @if(absenceEntry?.approvedBy == null && state.userHasMinType(1)){
      <ion-button
        style="width: 100%"
        color="success"
        (click)="approveEntry()"
        >{{ "common.confirm" | translate }}</ion-button
      >}
    </div>
  </div>
</ion-content>
